<script setup>
import store from '@/store/index.js'
import {router} from '@/router/index.js'
import {watch, reactive, ref, computed} from "vue";
import {useRoute} from 'vue-router';
import setting from '@/settings.js'
import {useStore} from 'vuex';

const route = useRoute();
const userInfo = ref(null)

const logout = () => {
  store.commit('user/logout');
}
const settings = () => {
  router.push('/user/info')
}
//const user = store.getters['user/getUserInfo'];
//const ustore = useStore();

// 把用户信息写成 computed → 实时更新！
const user = computed(() => store.getters['user/getUserInfo']);

//Object { username: "tangxia", nickname: "xx", total_value: 0, uuid: "37693cfc748049e45d87b8c7d8b9aacd", company: "xxx", token: "xxx.xx.x-x", remember: false, password: "" }
const menus = computed(() => {
  const menuList = [
    { icon: 'ShoppingCartFull', name: '添加订单', path: '/order/add' },
    { icon: 'DocumentCopy', name: '我的订单', path: '/order/my/index' },
  ];
  if (user.value?.username !== 'hxs1307') {
    menuList.push({icon: 'Monitor', name: '财务统计', affix: true, path: '/finance/statistics', });
  }  
  menuList.push({icon: 'Setting', name: '账号信息', affix: true, path: '/user/info', });
  return menuList;
});

let mainMenuActiveIndex = ref(0);

let defaultOpeneds = ref(['1']);
let isCollapse = ref(false);

const handleOpen = (key, keyPath) => {
  console.log('handleOpen', key, keyPath)
}
const handleClose = (key, keyPath) => {

  console.log('handleClose', key, keyPath)
}
const toggleExpand = () => {

  isCollapse.value = !isCollapse.value
  //alert(isCollapse.value);
}
watch(() => route.path, (newPath, oldPath) => {
  //console.log(`路由路径变化: ${oldPath} -> ${newPath}`);
  mainMenuActiveIndex.value = newPath
  let user = store.getters['user/getUserInfo'];
//alert(user)
  userInfo.value = {...user}
}, {immediate: false});
</script>

<template>
  <div v-if="$route.path === '/login'">
    <RouterView/>
  </div>
  <div class="common-layout" v-else>
    <el-container>

      <el-aside width="auto">

        <div class="main-slider-menu">
          <section class="site-title" :class="{ collapse: isCollapse}">
            <img src="./assets/logo.png" style="width: 44px" v-if="isCollapse"/>
            <img src="./assets/logo-h.png" style="width: 160px" v-else>
          </section>
          <el-menu
              :default-active="mainMenuActiveIndex"
              :default-openeds="defaultOpeneds"
              :unique-opened="true"
              @open="handleOpen"
              popper-effect="light"
              @close="handleClose"
              :router="true"
              :collapse="isCollapse"
          >

            <template v-for="(subMenu,index) in menus">
              <el-sub-menu :index="index+1+''" v-if="subMenu.children && subMenu.children.length > 0">
                <template #title>
                  <component class="icons" :is="subMenu.icon"/>
                  <span>{{ subMenu.name }}</span>
                </template>
                <template v-for="(childMenu,childIndex) in subMenu.children">
                  <el-menu-item :index="childMenu.path">{{ childMenu.name }}</el-menu-item>
                </template>
              </el-sub-menu>
              <el-menu-item :index="subMenu.path" v-else>
                <component class="icons" :is="subMenu.icon"/>
                <span>{{ subMenu.name }}</span>
              </el-menu-item>
            </template>
          </el-menu>
          <span class="version" v-if="!isCollapse">
           Version：{{ setting.version }}
         </span>
        </div>

      </el-aside>
      <el-container>
        <el-header>
          <section class="header-left">
            <section class="expand">
              <el-icon @click="toggleExpand" v-if="isCollapse">
                <Expand/>
              </el-icon>
              <el-icon @click="toggleExpand" v-if="!isCollapse">
                <Fold/>
              </el-icon>
            </section>
            <section class="breadcrumb">

            </section>
          </section>

          <p v-if="userInfo != null">
            <el-popover placement="bottom" :width="120" trigger="click">
              <template #reference>
                <span class="toggle-user-info">
                  <img src="./assets/avatar.png" style="width:28px;margin-right:5px"/>{{ userInfo.username }}<el-icon><CaretBottom/></el-icon>
                </span>
              </template>
              <section style="display: flex;flex-direction: column">
                <el-button size="large" @click="settings" style="border: 0">
                  <el-icon style="margin-right: 10px">
                    <Setting />
                  </el-icon>
                  账号信息
                </el-button>
                <el-button  size="large" @click="logout" style="border: 0;margin: 0">
                  <el-icon style="margin-right: 10px">
                    <SwitchButton/>
                  </el-icon>
                   退出登录
                </el-button>
              </section>
            </el-popover>

          </p>
        </el-header>
        <el-main>

          <template v-if="$route.meta && $route.meta.keep_alive === true">
            <router-view v-slot="{ Component }">
              <keep-alive>
                <component :is="Component"/>
              </keep-alive>
            </router-view>
          </template>
          <template v-else>
            <RouterView/>
          </template>
        </el-main>
        <el-footer>
          <section class="footer">
            &copy;版权所有&nbsp;&nbsp;侵权必究&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </section>
        </el-footer>
      </el-container>
    </el-container>
  </div>
</template>


<style scoped>
.common-layout {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: stretch;
}

.el-aside {
  background-color: #ffffff;
  display: flex;
  transition: all ease-in-out .2s;
}

.main-slider-bar {
  flex: 0 0 100px;
  border-right: 1px solid var(--el-menu-border-color);
}

.site-title {
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 80px;
  height: 80px;
  text-align: center;
  font-weight: bold;
  padding: 0 40px;
}

.site-title.collapse {
  padding: 0;
}

.site-title .title-label {
  letter-spacing: 3px;
  font-size: 26px;
}

.site-title.collapse .title-label {
  display: none;
}

.main-slider-bar ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.main-slider-bar ul li {
  border-radius: 6px;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  width: 60px;
  height: 60px;
  justify-content: center;
  margin: 5px auto;
}

.main-slider-bar ul li:hover, .main-slider-bar ul li.checked {
  background-color: #333;
  color: #fff;
  cursor: pointer;
}

.main-slider-bar svg {
  width: 24px;
  height: 24px;
}

.main-slider-menu {
  position: relative;
  border-right: 1px solid var(--el-menu-border-color);
}

.version{
  color: #000;
  font-size: 12px !important;
  width: 100%;
  position: absolute;
  left: 0;
  bottom:30px;
  text-align: center;
}

.main-slider-menu svg {
  width: 26px;
  height: 26px;
  margin-right: 5px;
}

.main-slider-menu span {
  font-size: 16px;
}

.el-menu {
  border: 0 !important;
}

.el-header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  --el-header-padding: 0 10px;
  margin: 0 10px;
  border-bottom: 1px solid var(--el-menu-border-color);
}

.expand .el-icon {
  cursor: pointer;
}

.toggle-user-info {
  cursor: pointer;
  display: flex;
  align-items: center;
  border: 0;
}

.toggle-user-info:hover {
  border: 0;
}

.toggle-user-info:active {
  border: 0;
}


.footer {
  border-top: 1px solid var(--el-menu-border-color);
  line-height: 40px;
  text-align: right;
  font-size: 14px;
  color: #666666;
}

</style>
